import { AlgoliaDfrEntry } from '@newmoon-org/types';

import { DfrState } from '@/store/dfr/index';

export default {
  getSelected: (state: DfrState): AlgoliaDfrEntry[] => state.selected,
};
